/* lua.js generated code 0.3.0 */

require("clover/const/QualityConst")
var numberLineParticles = 0
var GameGuideTimelineFx = xClass("GameGuideTimelineFx")
GameGuideTimelineFx.create = function (vertical) {
    var self = this
    var ret = cc.Node.create()
    var a = self.buildLineEffect(false)
    if (vertical) {
        a.setRotation(90)
    }
    ret.addChild(a)
    // var b = self.buildLineWater()
    // ret.addChild(b)
    return ret
}
var bubbleAnimation = null
GameGuideTimelineFx.getBubbleAnimation = function () {
    var self = this
    if (bubbleAnimation == null) {
        var frames = SpriteUtil.buildFrames("line_bubble_%04d.png", 0, 16)
        bubbleAnimation = SpriteUtil.buildAnimate(frames, 1 / 40)
        bubbleAnimation.retain()
    }
    // WARN: maybe multi result
    return bubbleAnimation.clone()
}
GameGuideTimelineFx.buildLineEffect = function (onlyRight) {
    var self = this
    var node = cc.Sprite.create()
    FrameLoader.loadImageWithPlist("flash/explode.plist")
    function buildLightLine2(direction) {
        var sprite = cc.Sprite.createWithSpriteFrameName("line_back.png")
        sprite.setScaleX(direction)
        sprite.setOpacity(0)
        sprite.setAnchorPoint(ccp(0.65, 0.5))
        var lineAnimationTime = 0.25
        function onLightAnimationEnd() {
            if (sprite && !sprite.isDisposed) {
                sprite.stopAllActions()
                sprite.runAction(cc.Spawn.create(cc.MoveBy.create(0.15, ccp(170 * direction, 0)), cc.FadeOut.create(0.15), cc.ScaleTo.create(0.15, 8 * direction, 0.3)))
            }
        }
        var array = LuaArray.create()
        array.addObject(cc.ScaleTo.create(0.3, 12 * direction, 1.2))
        array.addObject(cc.FadeIn.create(0.1))
        array.addObject(cc.MoveBy.create(0.3, ccp(765 * direction, 0)))
        array.addObject(cc.Sequence.create(cc.DelayTime.create(0.3), cc.CallFunc.create(onLightAnimationEnd)))
        sprite.runAction(cc.Spawn.create(array.toLuaArray()))
        return sprite
    }
    // function createStars() {
    //     var __VA_ARG = $slice(arguments, 0)
    //     // body
    //     var maxStar = 10
    //     var $limit17 = maxStar
    //     for (var k = 1; k <= $limit17; k += 1) {
    //         var sprite = cc.Sprite.createWithSpriteFrameName("star.png")
    //         sprite.setScale(math.random())
    //         sprite.setOpacity(0)
    //         var x = (k - 5) * 50
    //         var index = k % 2 === 0 && 1 || -1
    //         var y = math.random() * 20 * index
    //         sprite.setPosition(ccp(x, y))
    //         var actionList = LuaArray.create()
    //         actionList.addObject(cc.FadeIn.create(0.1))
    //         actionList.addObject(cc.DelayTime.create(0.5))
    //         actionList.addObject(cc.FadeOut.create(0.2))
    //         actionList.addObject(cc.CallFunc.create(function () {
    //             sprite.removeFromParent(true)
    //         }))
    //         sprite.runAction(cc.Spawn.create(cc.Sequence.create(actionList.toLuaArray()), cc.RotateBy.create(2, 720)))
    //         node.addChild(sprite)
    //     }
    // }
    function onLightAnimationBegin() {
        var right = buildLightLine2(1)
        right.setPosition(55, 0)
        node.addChild(right, 0)
        if (!onlyRight) {
            var left = buildLightLine2(-1)
            left.setPosition(-55, 0)
            node.addChild(left, 0)
        }
    }
    // function createFog() {
    //     for (var i = 1; i <= 20; i += 1) {
    //         var sprite = cc.Sprite.createWithSpriteFrameName("fog.png")
    //         sprite.setOpacity(0)
    //         sprite.setPosition(ccp((i > 10 && (10 - i) || i) * 55, 0))
    //         var actionList = LuaArray.create()
    //         actionList.addObject(cc.FadeIn.create(0.03 * (10 - i)))
    //         actionList.addObject(cc.DelayTime.create(0.1))
    //         actionList.addObject(cc.FadeOut.create(0.1))
    //         actionList.addObject(cc.CallFunc.create(function () {
    //             sprite.removeFromParent(true)
    //         }))
    //         sprite.runAction(cc.Sequence.create(actionList.toLuaArray()))
    //         node.addChild(sprite)
    //     }
    //     for (var i = 1; i <= 10; i += 1) {
    //         var destroySprite = cc.Sprite.createWithSpriteFrameName("line_bubble_0000.png")
    //         destroySprite.setRotation((i > 5 && -1 || 1) * 90)
    //         destroySprite.setPosition(ccp((i > 5 && (5 - i) || i) * 155, 0))
    //         var animate = GameGuideTimelineFx.getBubbleAnimation()
    //         function onFinish() {
    //             destroySprite.removeFromParent(true)
    //         }
    //         destroySprite.play(animate, (i > 5 && -(5 - i) || i) * 0.08, 1, onFinish)
    //         node.addChild(destroySprite)
    //     }
    // }
    function onAnimationFinished() {
        node.removeFromParent(true)
        numberLineParticles = numberLineParticles - 1
        if (numberLineParticles < 0) {
            numberLineParticles = 0
        }
    }
    var array = LuaArray.create()
    array.addObject(cc.DelayTime.create(0.1))
    array.addObject(cc.CallFunc.create(onLightAnimationBegin))
    // var displayParticles = true
    // if (numberLineParticles > Quality.kLineEffectMaxNum) {
    //     displayParticles = false
    //     if (math.random() < 0.35) {
    //         displayParticles = true
    //     }
    // }
    // if (_G.__use_low_effect || cc.Director.getInstance().getAvgFrameRate() < Quality.kFPSGuardLine) {
    //     displayParticles = false
    // }
    // if (displayParticles) {
    //     numberLineParticles = numberLineParticles + 1
    //     createStars()
    //     array.addObject(cc.CallFunc.create(createFog))
    // }
    array.addObject(cc.DelayTime.create(1.2))
    array.addObject(cc.CallFunc.create(onAnimationFinished))
    node.runAction(cc.Sequence.create(array.toLuaArray()))
    return node
}
// GameGuideTimelineFx.buildLineWater = function () {
//     var self = this
//     var destroySprite
//     var frames
//     var animate
//     destroySprite = cc.Sprite.createWithSpriteFrameName("line_water_effect_0000.png")
//     frames = SpriteUtil.buildFrames("line_water_effect_%04d.png", 0, 23)
//     animate = SpriteUtil.buildAnimate(frames, 1 / 40)
//     function onRepeatFinishCallback_DestroyEffect() {
//         destroySprite.removeFromParent(true)
//     }
//     destroySprite.play(animate, 0, 1, onRepeatFinishCallback_DestroyEffect)
//     return destroySprite
// }
module.exports = GameGuideTimelineFx
